import { render, staticRenderFns } from "./ModalHoldBill.vue?vue&type=template&id=1171a58c&scoped=true"
import script from "./ModalHoldBill.vue?vue&type=script&lang=js"
export * from "./ModalHoldBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1171a58c",
  null
  
)

export default component.exports